export enum ROUTES {
  /* PLOP_INJECT_ENUM */
  Referrals = '/referrals',
  ReferralLanding = '/r/:ref',
  Investors = '/investors',
  InvestorAdmin = '/investors/admin',
  PublicStats = '/stats/:slug',
  PublicBracket = '/brackets/:slug',
  BracketMatchRoom = '/brackets/:slug/match/:matchId',
  CommunityBracketEditor = '/community/:communityId/brackets/:competitionId/edit',
  LanQueue = '/queue/play',
  QueueStats = '/queue/stats',
  PrivacyPolicy = '/privacy',
  TermsOfService = '/terms-of-service',
  Community = '/community',
  CommunityDetail = '/community/:communityId',
  NewsDetail = '/shout/:newsId',
  CommentFocus = '/shout/:newsId/comment/:commentId',
  TournamentDetail = '/tournament/:tournamentId',
  TournamentMatchDetail = '/tournament/:tournamentId/match/:matchId',
  Tournament = '/tournaments',
  Team = '/teams',
  TeamDetail = '/team/:teamId',
  TeamStratBoard = '/team/:teamId/strat-board',
  Profile = '/profile/:username',
  UserActivate = '/users/activate/:token',
  League = '/leagues',
  LeagueDetail = '/leagues/:leagueId',
  LeaguePlace = '/leagues/:leagueId/place',
  LeagueByGame = '/leagues/game/:gameId',
  AdminLeagues = '/admin/leagues',
  AdminLeagueManage = '/admin/league/:leagueId/manage',
  AdminLeagueTeams = '/admin/league/:leagueId/teams',
  AdminTeams = '/admin/teams',
  AdminUserLocations = '/admin/user-locations',
  LeagueManagement = '/league/:leagueId/manage',
  MatchRoom = '/match/:matchId',
  QueueMatchDetail = '/queue/match/:matchId',
  Store = '/store',
  Forum = '/forums',
  Home = '/',
  Hub = '/hub',
  Explore = '/explore',
  Game = '/games',
  GameDetail = '/game/:gameId',
  Notifications = '/notifications',
  Wallet = '/wallet',
  StreamDashboard = '/stream/dashboard',
  StreamLive = '/stream/live/:username',
  StreamBrowse = '/streams',
  GameServers = '/game-servers',
  GameServersPaymentSuccess = '/game-servers/payment-success',
  DePIN = '/depin',
  Token = '/token',
  GameServer = '/game-server',
  GameServerGame = '/game-server/:gameSlug',
  Nodes = '/nodes',
  Studios = '/studios',
  EmailPreferences = '/email/preferences/:token',
}

export const getNewsDetailRoute = (newsId: string) => `/shout/${newsId}`

export const getCommentFocusRoute = (newsId: string, commentId: string) => `/shout/${newsId}/comment/${commentId}`

export const getGameDetailRoute = (gameId: string) => `/game/${gameId}`

export const getTeamDetailRoute = (teamId: string) => `/team/${teamId}`

export const getTournamentDetailRoute = (tournamentId: string) =>
  `/tournament/${tournamentId}`

export const getTournamentMatchDetailRoute = (
  tournamentId: string,
  matchId: string,
) => `/tournament/${tournamentId}/match/${matchId}`

export const getProfileDetailRoute = (username: string) =>
  `/profile/${username}`

export const getStreamLiveRoute = (username: string) =>
  `/stream/live/${username}`

export const getLeagueDetailRoute = (leagueId: string) =>
  `/leagues/${leagueId}`

export const getLeaguePlaceRoute = (leagueId: string) =>
  `/leagues/${leagueId}/place`

export const getLeagueByGameRoute = (gameId: string) =>
  `/leagues/game/${gameId}`

export const getLeagueManagementRoute = (leagueId: string) =>
  `/league/${leagueId}/manage`

export const getCommunityDetailRoute = (communityId: string) =>
  `/community/${communityId}`

export const getMatchRoomRoute = (matchId: string) =>
  `/match/${matchId}`

export const getQueueMatchDetailRoute = (matchId: string) =>
  `/queue/match/${matchId}`

export const getPublicStatsRoute = (slug: string) =>
  `/stats/${slug}`

export const getPublicBracketRoute = (slug: string) =>
  `/brackets/${slug}`

export const getBracketMatchRoomRoute = (slug: string, matchId: string) =>
  `/brackets/${slug}/match/${encodeURIComponent(matchId)}`

export const getCommunityBracketEditorRoute = (communityId: string, competitionId: string) =>
  `/community/${communityId}/brackets/${competitionId}/edit`
